import { TooltipModel, TooltipModelProps } from '@mail/3promo/models/tooltip';
import { ReactRenderer } from '@mail/3promo/render/react';
import { LocalStorageStore } from '@mail/3promo/stores/localStorage';
import type { ModelCreator } from '@mail/3promo/types';
import { xray } from 'lib/xray';
import { PdfAutosavePromo } from 'reactApp/modules/promoNew/components/PdfAutosave/PdfAutosavePromo';

import { PDF_AUTOSAVE_PROMO } from '../defaultValues';

export const pdfAutosaveCreator: ModelCreator = ({ models, render, stores }) =>
    new TooltipModel(
        PDF_AUTOSAVE_PROMO,
        models.base,
        new TooltipModelProps(PDF_AUTOSAVE_PROMO, {
            store: new LocalStorageStore(PDF_AUTOSAVE_PROMO, stores.localStorage),
            renderer: new ReactRenderer(PDF_AUTOSAVE_PROMO, PdfAutosavePromo, render.react),
            closable: true,
            hideOnOutsideClick: true,
            templateData: {
                title: 'Автосохранение файла',
                text: 'Вы можете включать или выключить автосохранение изменений в PDF',
            },
            getTarget: () => {
                return document.querySelector("[data-qa-id='more-button-pdf']");
            },
            onShow: () => {
                xray.send(`pdf-autosave-promo-show`);
            },
            onClose: () => {
                xray.send(`pdf-autosave-promo-close`);
            },
        })
    );
